export default "__VITE_ASSET__DBC4t$Tk__"